var exports = {
  "iE": "xaf9ae18d--67f5c7--wrapper",
  "Sl": "xaf9ae18d--67f5c7--image",
  "Zm": "xaf9ae18d--67f5c7--newbuilding-image",
  "pr": "xaf9ae18d--67f5c7--developer-logo",
  "Qs": "xaf9ae18d--67f5c7--content",
  "DD": "xaf9ae18d--67f5c7--title",
  "hl": "xaf9ae18d--67f5c7--address",
};

module.exports = exports;
